import { Card } from '@ipfabric/ui-components/Card/Card';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { storedAimWorkloads } from '../../../snippets/storedAimWorkloads';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const aimWorkloadsGroup = createFormSnippetGroup({
  snippets: {
    aimWorkloads: storedAimWorkloads,
  },
  render: ({ renderSnippet }) => (
    <SearchableSection
      id='aim-workloads'
      searchTerms={['Workload list']}
      highlightOn={['aimWorkloads']}
      className='flex flex-col flex-1'
      wrapperClassName='flex flex-col flex-1'
    >
      <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
        <SearchableSection
          id='aim-workloads'
          className='flex flex-col flex-1'
          wrapperClassName='flex flex-col flex-1'
          highlightOn={['applicationMapping']}
        >
          {renderSnippet('aimWorkloads')}
        </SearchableSection>
      </Card>
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('applicationMapping');
    control.setApplicationMappingSubTab('aimWorkloads');
  },
});
